import { Components, hooks } from 'botframework-webchat';
import React, { useEffect, useState } from 'react';
const { Composer, BasicWebChat } = Components;
const { useScrollTo, useActivities } = hooks;
const PreventScrollToBottonOnWelcomeMessage = () => {
    const scrollTo = useScrollTo();
    const [activities] = useActivities();
    const [initialActivitiesHandled, setInitialActivitiesHandled] = useState(false);
    useEffect(() => {
        if (!initialActivitiesHandled) {
            const messages = activities.filter((a) => a.type === 'message');
            if (messages.length > 0) {
                setInitialActivitiesHandled(true);
                if (messages[0].from.role !== 'user') {
                    scrollTo({ scrollTop: 0 }, {});
                }
            }
        }
    }, [activities, scrollTo]);
    return React.createElement(React.Fragment, null);
};
export const BFFWebChat = (props) => {
    return (React.createElement(Composer, Object.assign({}, props),
        React.createElement(BasicWebChat, { className: "bffWebChat" }),
        React.createElement(PreventScrollToBottonOnWelcomeMessage, null)));
};
//# sourceMappingURL=bffWebChat.js.map